import { isValidUrl } from '.';
import SimpleArtist, {
  ArtistPlatformRecord,
} from '../../../../../common/types/artist/simple-artist';
import { NewInstance } from '../../../../../common/types/data/new-instance';
import { ArtistSearchResult } from '../../../../../services/artist/types/artist-search-result';

export const validateRequiredPlatform = (platform?: string) => {
  return platform && platform?.length > 0;
};

export const validateSpotifyUrl = (url?: string) => {
  return (
    url &&
    (url === 'NEW' ||
      url.startsWith('spotify:artist') ||
      url.toLowerCase().startsWith('https://open.spotify.com/artist/'))
  );
};

export const validatePlatform = (platform?: string) => {
  return platform && platform.length > 0
    ? isValidUrl(platform) || platform === 'NEW'
    : true;
};

export const validateExternalId = (externalId?: ArtistSearchResult) => {
  return isValidUrl(externalId?.id);
};

export const validateArtistsPlatforms = (platforms?: ArtistPlatformRecord) => {
  return (
    validatePlatform(platforms?.spotify) &&
    validateSpotifyUrl(platforms?.spotify) &&
    validatePlatform(platforms?.apple) &&
    validatePlatform(platforms?.soundcloud)
  );
};

export const validateAllPlatforms = (
  platforms?: ArtistPlatformRecord
): boolean => {
  return !!(
    platforms &&
    validateRequiredPlatform(platforms.spotify) &&
    validateArtistsPlatforms(platforms)
  );
};

export const validateArtist = (
  artistData?: NewInstance<SimpleArtist>,
  checkPlatforms: boolean = true
) => {
  return (
    !!artistData?.name &&
    artistData?.name.length > 0 &&
    (!checkPlatforms || !!validateArtistsPlatforms(artistData?.platforms))
  );
};
